// extracted by mini-css-extract-plugin
module.exports = {"formModal":"questions-container_formModal__3EoBV","linkedQuestion":"questions-container_linkedQuestion__1tC63"};